import type { Course } from './Course';
import type { User } from './User';

export const hasSubcategoryAccess = (
  user: User | null,
  isAdmin: boolean,
  subcategoryId: string | undefined,
): boolean => {
  if (!user) return false;
  if (isAdmin) return true;
  if (!subcategoryId) return false;
  return user.purchasedSubcategories?.includes(subcategoryId) ?? false;
};

export const hasCourseAccess = (course: Course | null, hasSubcatAccess: boolean): boolean => {
  if (!course) return false;
  if (course.preview) return true;
  return hasSubcatAccess;
};
